var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI03Layer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2624 3.65009L23.6374 6.92509C25.7624 7.86259 25.7624 9.41258 23.6374 10.3501L16.2624 13.6251C15.4249 14.0001 14.0499 14.0001 13.2124 13.6251L5.8374 10.3501C3.7124 9.41258 3.7124 7.86259 5.8374 6.92509L13.2124 3.65009C14.0499 3.27509 15.4249 3.27509 16.2624 3.65009Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.75C3.75 14.8 4.5375 16.0125 5.5 16.4375L13.9875 20.2125C14.6375 20.5 15.375 20.5 16.0125 20.2125L24.5 16.4375C25.4625 16.0125 26.25 14.8 26.25 13.75",
    stroke: "#6E6E6E",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 20C3.75 21.1625 4.4375 22.2125 5.5 22.6875L13.9875 26.4625C14.6375 26.75 15.375 26.75 16.0125 26.4625L24.5 22.6875C25.5625 22.2125 26.25 21.1625 26.25 20",
    stroke: "#6E6E6E",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI03Layer);
export default __webpack_public_path__ + "static/media/I03-layer.d4260c1cc57964463ed065192a50cedb.svg";
export { ForwardRef as ReactComponent };